import { createSelector } from '@reduxjs/toolkit';
import { normalizeParamsConnection } from 'ducks/batch-definition/utils';
import { ModalsState } from 'ducks/modals/slices';
import { CardInfo } from 'ducks/types/common-types';
import { RootState } from 'store';

const modalsSlice = (state: RootState) => state.modals;

export const selectModals = createSelector([modalsSlice], (state): ModalsState => state);

export const selectApiErrorModal = createSelector([modalsSlice], (state): ModalsState['api_error'] => state.api_error);
export const selectAdvancedFiltering = createSelector(
  [modalsSlice],
  (state): ModalsState['advanced_filtering'] => state.advanced_filtering,
);
export const selectManageScheduleBatch = createSelector(
  [modalsSlice],
  (state): ModalsState['manage_schedule_batch'] => state.manage_schedule_batch,
);
export const selectRunBatchDefinition = createSelector(
  [modalsSlice],
  (state): ModalsState['run_batch_definition'] => state.run_batch_definition,
);
export const selectRunScheduleBatch = createSelector(
  [modalsSlice],
  (state): ModalsState['run_schedule_batch'] => state.run_schedule_batch,
);
export const selectScheduleBatchHistory = createSelector(
  [modalsSlice],
  (state): ModalsState['schedule_batch_history'] => state.schedule_batch_history,
);
export const selectManageParameter = createSelector(
  [modalsSlice],
  (state): ModalsState['manage_parameter'] => state.manage_parameter,
);
export const selectCreateParameter = createSelector(
  [modalsSlice],
  (state): ModalsState['create_parameter'] => state.create_parameter,
);
export const selectCreateParameterView = createSelector(
  [modalsSlice],
  (state): ModalsState['create_parameter_view'] => state.create_parameter_view,
);
export const selectEditJob = createSelector([modalsSlice], (state): ModalsState['edit_job'] => state.edit_job);
export const selectStopJob = createSelector([modalsSlice], (state): ModalsState['stop_job'] => state.stop_job);
export const selectCreateJobDefinition = createSelector(
  [modalsSlice],
  (state): ModalsState['create_job_definition'] => state.create_job_definition,
);
export const selectRunJobDefinition = createSelector(
  [modalsSlice],
  (state): ModalsState['run_job_definition'] => state.run_job_definition,
);

export const selectCardInfo = createSelector([modalsSlice], (state): CardInfo => state.parameter_connections.card_info);
export const selectCardInfoName = createSelector(
  [modalsSlice],
  (state): CardInfo['batch_definition_item_name'] => state.parameter_connections.card_info.batch_definition_item_name,
);
export const selectCardInfoIds = createSelector(
  [modalsSlice],
  (state): CardInfo['children_item_ids'] => state.parameter_connections.card_info.children_item_ids,
);
export const selectCardParent = createSelector(
  [modalsSlice],
  (state): CardInfo['current_params'] => state.parameter_connections.card_info.current_params,
);
export const selectCardChildrens = createSelector(
  [modalsSlice],
  (state): CardInfo['children_params'] => state.parameter_connections.card_info.children_params,
);
export const selectCardChildren = createSelector([modalsSlice], (state) =>
  normalizeParamsConnection(
    state.parameter_connections.card_info?.current_params,
    state.parameter_connections.card_info?.children_params,
  ),
);

export const selectParameterConnections = createSelector(
  [modalsSlice],
  (state): ModalsState['parameter_connections'] => state.parameter_connections,
);
export const selectParameterConnectionsView = createSelector(
  [modalsSlice],
  (state): ModalsState['parameter_connections_view'] => state.parameter_connections_view,
);
export const selectCreateProject = createSelector(
  [modalsSlice],
  (state): ModalsState['create_project'] => state.create_project,
);
export const selectManageUser = createSelector([modalsSlice], (state): ModalsState['manage_user'] => state.manage_user);
export const selectChangePassword = createSelector(
  [modalsSlice],
  (state): ModalsState['change_password'] => state.change_password,
);
export const selectSuccess = createSelector([modalsSlice], (state): ModalsState['success'] => state.success);
export const selectSuccessReset = createSelector(
  [modalsSlice],
  (state): ModalsState['success_reset'] => state.success_reset,
);
export const selectWarning = createSelector([modalsSlice], (state): ModalsState['warning'] => state.warning);
